import React from 'react';
import UserRow from './UserRow';
import SearchForm from './SearchForm';

const UserTable = (props) => {
  const {
    users,
    mcode,
    cd,
    setCd
  } = props;
  return (
    <div>
      <table className="table table-bordered" id="user_table">
        <thead>
          <tr>
            <th className="col-md-3">Name</th>
            <th className="col-md-2">Email address</th>
            <th className="col-md-1" style={{ textAlign: 'center' }}>Authority</th>
            <th className="col-md-1" style={{ textAlign: 'center' }}>Core Time</th>
            <th className="col-md-2">Date of hire</th>
            <th className="col-md-2"><SearchForm cd={cd} setCd={setCd} /></th>
            <th className="col-md-2">UserProfile</th>
          </tr>
        </thead>
        <tbody>
          {users && users.map((user, index) => (
            <UserRow key={index} user={user} mcode= {mcode}/>
          ))}
        </tbody>
      </table>
      {users.length > 0 ? (
        null
      ) : (
        <p style={{ textAlign: "center" }}>No Data Available</p>
      )}
    </div>
  );
};

export default UserTable;
